var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999994 0.000157422C0.447712 0.000162128 0 0.447876 0 1.00016V12.1293C0 12.6816 0.447715 13.1293 1 13.1293H19.4735C19.7642 13.1293 20 12.8935 20 12.6026V0.526704C20 0.235806 19.7642 0 19.4735 0L0.999994 0.000157422Z",
    fill: "#7888AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4735 0.000976562H16.8096L10.0001 4.47083L3.18894 0.000976562H2.09487C0.937906 0.000976562 0 0.938881 0 2.09585V2.09585L6.80966 6.56553L0 11.036V11.036C0 12.1926 0.937533 13.1301 2.09404 13.1301H3.19043L9.99992 8.6604L16.8107 13.1301H19.4735C19.7642 13.1301 20 12.8943 20 12.6035V11.0354L13.1903 6.56553L20 2.09502V0.527515C20 0.236782 19.7642 0.000976562 19.4735 0.000976562Z",
    fill: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.04874L8.40487 6.56553H10.8023L0.800843 0.000976562V0.000976562C0.35855 0.000976562 0 0.359526 0 0.801819V1.04874Z",
    fill: "#FB695B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5947 6.56445H9.19727L19.1983 13.129H19.473C19.7637 13.129 19.9995 12.8932 19.9995 12.6025V12.0814L11.5947 6.56445Z",
    fill: "#FB695B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19874 6.56445L0 12.6023V12.6023C0 12.8932 0.235814 13.129 0.526705 13.129H1.59521L10.0001 7.61205L9.19874 6.56445Z",
    fill: "#FB695B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4734 0H18.4047L10 5.51695L10.8012 6.56456L19.9999 0.526538C19.9999 0.235806 19.7641 0 19.4734 0V0Z",
    fill: "#FB695B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.37724H12.1882V0.000976562H7.81179V4.37724H0V8.75366H7.81179V13.1301H12.1882V8.75366H20V4.37724Z",
    fill: "#F4F4F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.25259H11.3129V0.000976562H8.68714V5.25259H0V7.87831H8.68714V13.1301H11.3129V7.87831H20V5.25259Z",
    fill: "#FB695B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.6ef6b217337a0d9e9ed6900ed014fed2.svg";
export { ForwardRef as ReactComponent };